import clsx from 'clsx'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'

import { ISearchResponse } from '@/_types/search'

import { useHeaderScroll } from '../../_hooks'
import { useHeaderPathname } from '../../_utils/useHeaderPathname'

import ADesktopHeaderMain from './a-desktop-header-main'
import ADesktopHeaderTop from './a-desktop-header-top'

export default function ADesktopHeader({
	onMenuToggle,
	onLinkClick,
	searchOpen,
	setSearchOpen,
	searchQuery,
	onSearchQueryChange,
	onSearchClose,
	searchData,
	isSearchLoading,
	isSearching,
	hasSearchTerm
}: {
	onMenuToggle: () => void
	onLinkClick: () => void
	searchOpen: boolean
	setSearchOpen: Dispatch<SetStateAction<boolean>>
	searchQuery: string
	onSearchQueryChange: (query: string) => void
	onSearchClose: () => void
	searchData: ISearchResponse | undefined
	isSearchLoading: boolean
	isSearching: boolean
	hasSearchTerm: boolean
}) {
	const { isScrolled } = useHeaderScroll()
	const pathname = useHeaderPathname()

	const [topHeaderStyle, setTopHeaderStyle] = useState<'normal' | 'transparent'>('normal')
	const [forceScrolledStyle, setForceScrolledStyle] = useState<boolean>(false)

	useEffect(() => {
		if (
			pathname.startsWith('/ambulancie/') ||
			pathname.startsWith('/povedali-o-nas') ||
			pathname.startsWith('/kariera/') ||
			pathname.startsWith('/casto-kladene-otazky') ||
			pathname.startsWith('/preventivne-prehliadky/') ||
			pathname.startsWith('/medante-solo-pedi') ||
			pathname.startsWith('/volne-terminy')
		) {
			setTopHeaderStyle('transparent')
		} else {
			setTopHeaderStyle('normal')
		}

		if (pathname.startsWith('/clanky/')) {
			setForceScrolledStyle(true)
		} else {
			setForceScrolledStyle(false)
		}
	}, [pathname])

	return (
		<div
			className={clsx('desktop-header', {
				'desktop-header--collapsed': isScrolled || forceScrolledStyle
			})}
		>
			<ADesktopHeaderTop
				onLinkClick={onLinkClick}
				topHeaderStyle={topHeaderStyle}
				searchOpen={searchOpen}
				setSearchOpen={setSearchOpen}
				searchQuery={searchQuery}
				onSearchQueryChange={onSearchQueryChange}
				onSearchClose={onSearchClose}
				searchData={searchData}
				isSearchLoading={isSearchLoading}
				isSearching={isSearching}
				hasSearchTerm={hasSearchTerm}
			/>
			<ADesktopHeaderMain onMenuToggle={onMenuToggle} onLinkClick={onLinkClick} />
		</div>
	)
}
